import { IRequestContext } from '@msdyn365-commerce/core';
import { getFallbackImageUrl } from '../data-actions/utilities/utils';

export const urlFallBackImage = (imageUrl: string, itemId: string | undefined, apiSettings: IRequestContext) => {
    let fallbackImageUrl = getFallbackImageUrl(itemId, apiSettings?.apiSettings);
    if (imageUrl && fallbackImageUrl) {
        fallbackImageUrl = `${fallbackImageUrl},${imageUrl}`;
    }
    return fallbackImageUrl;
};